import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';

declare const bodymovin: any;

@Component({
  selector: 'common-animated-svg',
  templateUrl: './animated-svg.component.html',
  standalone: true,
  styleUrls: ['./animated-svg.component.scss'],
})
export class AnimatedSvgComponent implements OnChanges {
  anim: any;
  complete = false;
  @Input() loop = false;
  @Input() loopCount = 0;
  @Input() class = '';
  @Input() paused = false;
  @Input() svgName!: string;
  @Input() width = 140;
  @Input() height = 140;
  @Input() delayMs?: number;
  @Input() animateOnHover = false;
  @ViewChild('wrapper', { static: true }) wrapperElement!: ElementRef;
  @Output() animationComplete = new EventEmitter();

  ngOnChanges(): void {
    if (this.wrapperElement.nativeElement.innerHTML) this.wrapperElement.nativeElement.innerHTML = '';
    this.anim = bodymovin.loadAnimation({
      wrapper: this.wrapperElement.nativeElement,
      animType: 'svg',
      loop: this.loopCount ? this.loopCount : this.loop,
      autoplay: (this.loop || this.loopCount || !this.paused) && !this.delayMs,
      path: `./assets/animations/${this.svgName}.json`,
    });
    this.anim.setSpeed(1.5);
    this.anim.addEventListener('complete', () => {
      this.complete = true;
      this.animationComplete.emit();
    });

    if (this.delayMs) {
      setTimeout(() => {
        this.anim.play();
      }, this.delayMs);
    }

    this.anim.addEventListener('complete', () => {
      this.animationComplete.emit();
    });
  }

  onHover() {
    if (this.animateOnHover && this.complete) {
      this.anim.goToAndPlay(0);
    }
  }
}
